/*eslint backbone/no-constructor:0 */
define('glu/grid/cell/imageCell',['require','../../itemView','hbs!./imageCell.hbs'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        tpl = require('hbs!./imageCell.hbs');

    /**
     * This ItemView represents a simple image content.
     */
    return ItemView.extend({
        constructor: function(opts) {

            ItemView.prototype.constructor.call(this, opts);
        },
        template: tpl,

        templateHelpers: function() {

            return {
                id: this.model.cid
            };
        }
    });
});

